import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const EmptyMessage: React.FC<Props> = ({ children, className }) => {
  return <div className={classNames('p-5', className)}>{children}</div>;
};

export default EmptyMessage;
